import { render } from "./ChartProductosColumn.vue?vue&type=template&id=75049c8e"
import script from "./ChartProductosColumn.vue?vue&type=script&lang=js"
export * from "./ChartProductosColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__